import type { BadgeStatusVariant } from '@/shared/ui/Badge'

export type LibraryStatusBadge = { variant: BadgeStatusVariant; label: string }

/**
 * `null` quando o recurso está disponível — é o status-padrão (maioria pode
 * ser acessada), badge nesse caso é ruído. Tag existe pra sinalizar exceção
 * (bloqueado, concluído).
 */
export const getStatusBadge = (
  hasFinished: boolean,
  locked: boolean
): LibraryStatusBadge | null => {
  if (locked) return { variant: 'locked', label: 'Bloqueado' }
  if (hasFinished) return { variant: 'success', label: 'Concluído' }
  return null
}
